<template>
    <span class="badge badge-pill badge-primary" v-if="unreadCount">{{ unreadCount }}</span>
</template>

<script>
export default {
    props: {
        userId: {
            required: true,
            cast: Number
        }
    },

    data() {
        return {
            unreadCount: 0
        }
    },

    mounted() {
        axios
            .get(url(`/users/${this.userId}/messages/unread-count`))
            .then(response => this.unreadCount = response.data);
    }
}
</script>
